export default {
  me: {
    id: '',
    email: '',
    last_name: '',
    first_name: '',
    avatar: '',
    gravatar: '',
    is_streaming: '',
    company_name: '',
    company_id: 0,
    display_name: '',
    job_title: '',
    is_staff: false,
    is_admin: false,
  },
  userListSelectedUser: {
    id: '',
    email: '',
    last_name: '',
    first_name: '',
    avatar: '',
    gravatar: '',
    is_streaming: '',
    company_name: '',
    company_id: 0,
    display_name: '',
    job_title: '',
    is_staff: false,
    is_admin: false,
  },
  getUserListSelectedUserRequest: false,
  getUserListSelectedUserFailed: false,
  geUserListSelectedUserSuccess: false,

  getMePending: false,
  getMeFailed: false,
  getMeSuccess: false,
  groups: [],

  updatingProfile: false,
  updatingProfileFailed: false,
  updatingProfileSuccess: false,

  companyUsers: [],
  loadingCompanyUsers: false,
  loadingCompanyUsersFailed: false,
  loadingCompanyUsersSucceeded: false,
  loadingCompanyUsersErrors: null,

  updateCompanyUserRequest: false,
  updateCompanyUserSucceeded: false,
  updateCompanyUserFailed: false,
  updateCompanyUserErrors: null,

  updateUserLocaleRequest: false,
  updateUserLocaleSuccess: false,
  updateUserLocaleFailure: false,
  userCountryCode: null,

  loadingGroups: false,
  loadingGroupsFailed: false,
  loadingGroupsSucceeded: false,
};



// WEBPACK FOOTER //
// ./src/store/modules/user/state.js